import { type FC, useEffect } from 'react';
import { useLayoutSplashScreen } from './_LayoutSplashScreenProvider';

const LayoutSplashScreen: FC<{ visible?: boolean }> = ({ visible = true }) => {
  const { showSplashScreen, hideSplashScreen } = useLayoutSplashScreen();

  useEffect(() => {
    if (visible) {
      // Show SplashScreen
      showSplashScreen();
    } else {
      // Hide SplashScreen
      hideSplashScreen();
    }

    // Cleanup function to ensure splash screen is removed when component unmounts
    return () => {
      if (visible) {
        hideSplashScreen();
      }
    };
  }, [hideSplashScreen, showSplashScreen, visible]);

  return null;
};

export { LayoutSplashScreen };
